import React from 'react';
import { AppBar, Box, Button, Container, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import logo from '../../Assets/logo.png';

const PublicHeader = () => {
  const { pathname } = useLocation();
  const isHomePage = pathname === '/' || pathname === '/home';
  const isLoginPage = pathname === '/login';

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: 'rgba(255, 255, 246, 0.96)',
        color: '#173525',
        borderBottom: '1px solid rgba(47, 87, 65, 0.12)',
        backdropFilter: 'blur(14px)',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ px: { xs: 0, sm: 1 }, minHeight: '68px !important' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1 }}>
            <Box
              component="img"
              src={logo}
              alt="Nuvvy logo"
              sx={{ width: 42, height: 42, borderRadius: '8px', objectFit: 'cover' }}
            />
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
              Nuvvy
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {isLoginPage ? (
              <Button
                component={RouterLink}
                to="/"
                color="inherit"
                startIcon={<RestaurantMenuIcon />}
                sx={{ borderRadius: '999px', fontWeight: 800 }}
              >
                المنيو
              </Button>
            ) : null}

            {isHomePage ? (
              <Tooltip title="تسجيل الدخول">
                <IconButton
                  component={RouterLink}
                  to="/login"
                  aria-label="تسجيل الدخول"
                  sx={{
                    width: 44,
                    height: 44,
                    color: '#173525',
                    background: 'linear-gradient(145deg, #fcffde 0%, #e9f6a6 100%)',
                    border: '1px solid rgba(47, 87, 65, 0.18)',
                    boxShadow: '0 10px 24px rgba(23, 53, 37, 0.12)',
                    '&:hover': {
                      background: 'linear-gradient(145deg, #f7efbe 0%, #fcffde 100%)',
                      transform: 'translateY(-1px)',
                    },
                  }}
                >
                  <LoginIcon />
                </IconButton>
              </Tooltip>
            ) : null}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default PublicHeader;
